import type { TokenSchema } from './tokenSchema.ts';

// Shared sample handoff in the @alchmystudio/config TokenSchema shape (typed
// against the local mirror so it can't drift back to the old field names). Used
// by the designer build form and the admin/ops "Run sandbox build" control, so
// the two never diverge. Tweak a value (e.g. color.primary) and rebuild to prove
// the token → preview re-theme loop.
export function sampleTokens(): TokenSchema {
  return {
    typography: {
      fontFamilies: {
        heading: "'Fraunces', serif",
        body: "'Inter', sans-serif",
      },
      textStyles: {
        h1: { family: 'var(--font-heading)', size: '3rem', weight: 600, lineHeight: 1.1, letterSpacing: '-0.02em' },
        body: { family: 'var(--font-body)', size: '1rem', weight: 400, lineHeight: 1.6, letterSpacing: '0' },
      },
    },
    color: {
      background: '#0f0f0f',
      copy: '#f4f1ea',
      copySubtle: '#b8b3a7',
      primary: '#ff6633',
      primaryHover: '#e0552a',
      overlay: { color: '#000000', opacity: 0.5 },
    },
    spacing: { xs: '0.5rem', sm: '0.75rem', md: '1rem', lg: '1.5rem', xl: '2.5rem' },
    button: {
      default: { bg: '#ff6633', text: '#0f0f0f' },
      hover: { bg: '#e0552a', text: '#0f0f0f' },
      pressed: { bg: '#cc4a24', text: '#0f0f0f' },
      focus: { ring: '#ff6633' },
      radius: '0.5rem',
      padding: { y: 12, x: 24 },
    },
    grid: {
      // px ANCHORS — the system derives the fluid scaling (clamp curves) from each
      // anchor via fluidFromAnchor, so there are no min/max here. maxWidth caps the
      // design at the 27" studio display (2560 = fluid.upperViewport).
      columns: 12,
      gutter: 24,
      margin: 48,
      maxWidth: 2560,
      mobile: {
        columns: 4,
        gutter: 12,
        margin: 16,
      },
    },
    scale: 1.0,
    fluid: { upperViewport: '2560px', upperGrowth: 1.35 },
  };
}
